import PageForm from '../../../components/pageForm/PageForm';
import HeaderQualification from './components/header/header.qualification';
import BodyQualification from './components/content/body.qualification';
import SubNavbar from '../../../components/SubNavbar/SubNavbar';
import { useState } from 'react';
import MediaQuery from 'react-responsive';
import { useSearchParams } from 'react-router-dom';
import Button from '../../../components/button';
import { Filter, Plus, SearchLoop } from '../../../assets/icons';
import BottomSheet from '../../../components/bottomSheet/BottomSheet';
import StyledInput from '../../../components/styledInput/StyledInput';
import useSlideOver from '../../../components/SlideOver/useSlideOver';
import UseContext from '../../../hooks/useContext';
import { qualificationText } from '../../../components/SlideOver/dataSlideOver/data/slideOverQualification/qualificationTexts';

export const QUALIFICATION_SEARCH_OPTIONS = [
  { value: '', label: 'Tous' },
  { value: 'idBestt', label: 'ID BeSTT' },
  { value: 'name', label: 'Titre' },
  { value: 'codePCS', label: 'PCS' },
  { value: 'codeROME', label: 'ROME' },
];

export const SECTOR_CONFIG = {
  sale: { label: 'Vente', className: 'bg-gray-50 text-gray-600 ring-gray-500/10' },
  food: { label: 'Restauration', className: 'bg-green-50 text-green-600 ring-green-500/10' },
  logistic: { label: 'Logistique', className: 'bg-yellow-50 text-yellow-600 ring-yellow-500/10' },
  largeDistribution: { label: 'Grande distribution', className: 'bg-blue-50 text-blue-600 ring-blue-500/10' },
  administration: { label: 'Administration', className: 'bg-purple-50 text-purple-600 ring-purple-500/10' },
  industry: { label: 'Industrie', className: 'bg-orange-50 text-orange-600 ring-orange-500/10' },
  other: { label: 'Autre', className: 'bg-red-50 text-red-600 ring-red-500/10' },
};

const DISABLED_FILTER_OPTIONS = [
  { value: 'false', label: 'Non (actives uniquement)' },
  { value: 'true', label: 'Oui (désactivé uniquement)' },
  { value: 'null', label: 'Toutes' },
];

export const SearchTypeSelect = ({ value, onChange, options, className = '' }) => (
  <select
    className={`w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-md text-sm focus:border-yellow-500 focus:outline-none ${className}`}
    onChange={(e) => onChange(e.target.value)}
    value={value}
  >
    {(options || QUALIFICATION_SEARCH_OPTIONS).map((opt) => (
      <option key={opt.value} value={opt.value}>{opt.label}</option>
    ))}
  </select>
);

const Qualification = () => {
  // `?search=` comes from the similar qualifications listed by the AI
  // suggestion: a title search, disabled ones included since it may list them.
  const [searchParams] = useSearchParams();
  const initialSearch = searchParams.get('search') ?? '';
  const [search, setSearch] = useState(initialSearch);
  const [optionSearch, setOptionSearch] = useState(initialSearch ? 'name' : '');
  const [showDisabled, setShowDisabled] = useState(initialSearch ? null : false);

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tempSearch, setTempSearch] = useState('');
  const [tempOptionSearch, setTempOptionSearch] = useState('');
  const [tempShowDisabled, setTempShowDisabled] = useState(false);

  const { setObjID } = UseContext();
  const { toggleSlideOver } = useSlideOver();

  const openFilterSheet = () => {
    setTempSearch(search);
    setTempOptionSearch(optionSearch);
    setTempShowDisabled(showDisabled);
    setIsFilterOpen(true);
  };

  const applyFilters = () => {
    setSearch(tempSearch);
    setOptionSearch(tempOptionSearch);
    setShowDisabled(tempShowDisabled);
    setIsFilterOpen(false);
  };

  const addQualification = () => {
    setObjID('');
    toggleSlideOver('qualification');
  };

  return (
    <PageForm>
      <SubNavbar>
          <div className="flex justify-between items-center w-full gap-3">
            <MediaQuery minWidth={768}>
              <HeaderQualification
                search={search}
                setSearch={setSearch}
                optionSearch={optionSearch}
                setOptionSearch={setOptionSearch}
                showDisabled={showDisabled}
                setShowDisabled={setShowDisabled}
              />
            </MediaQuery>

            <MediaQuery maxWidth={767}>
              <Button color="SECONDARY" size="SM" onClick={openFilterSheet}>
                <Filter wh={16} color="#374151" />
                <span>Filtrer</span>
              </Button>
            </MediaQuery>

            <div className="flex items-center gap-3 flex-shrink-0">
              <Button color="PRIMARY" size="SM" className="h-10" onClick={addQualification}>
                <Plus wh={18} color="#FFFFFF" />
                <span>{qualificationText('list.create')}</span>
              </Button>
            </div>
          </div>
        </SubNavbar>

        <BodyQualification search={search} optionSearch={optionSearch} showDisabled={showDisabled} />

        <BottomSheet isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} title="Filtrer">
          <div className="flex flex-col gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Rechercher</label>
              <StyledInput
                type="text"
                placeholder="Rechercher..."
                imgFront={<SearchLoop wh={16} color="#6B7280" />}
                value={tempSearch}
                onChange={(e) => setTempSearch(e.target.value)}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Rechercher par</label>
              <SearchTypeSelect value={tempOptionSearch} onChange={setTempOptionSearch} className="rounded-lg" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Qualifications désactivées</label>
              <select
                className="w-full h-10 pl-3 pr-8 ft-b placeholder-gray-600 border rounded-lg text-sm focus:border-yellow-500 focus:outline-none"
                onChange={(e) => {
                  const val = e.target.value;
                  setTempShowDisabled(val === 'null' ? null : val === 'true');
                }}
                value={tempShowDisabled === null ? 'null' : String(tempShowDisabled)}
              >
                {DISABLED_FILTER_OPTIONS.map((opt) => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
            <Button color="PRIMARY" size="FULL" onClick={applyFilters} className="w-full mt-2">
              Appliquer
            </Button>
          </div>
        </BottomSheet>
    </PageForm>
  );
};

export default Qualification;
